module.exports = __webpack_public_path__ + "media/src/application/media/animation/step-1-7041c64af9c889962f62290afb8b9676.svg";